<template>
  <div class="footer">
    <div class="container footer-desktop">
      <div class="el-row">
        <div class="el-col-6">
          <div class="footer-logo-wrapper">
            <router-link to="/" tag="a" class="footer-logo-content">
              <img
                class="logo-image"
                alt="logo"
                :src="logoData.image"
              />
              <div class="logo-text-wrapper" v-if="logoData.title">
                <span v-for="(item, i) in logoData.title.split(' ')" :key="i">{{
                  item
                }}</span>
              </div>
            </router-link>
            <a class="footer-confidential" href="#">
              Політика конфіденційності
            </a>
          </div>
        </div>
        <ul class="el-col-18 footer-menu-container">
          <li class="footer-menu-lists">
            <div class="footer-menu-list-item footer-title">Меню</div>
            <div class="footer-menu-list-item">
              <router-link :to="{ name: 'about-us' }">Про нас</router-link>
            </div>
            <div class="footer-menu-list-item"><a href="#">Вакансії</a></div>
          </li>
          <li class="footer-menu-lists">
            <div class="footer-menu-list-item footer-title">Контакти</div>
            <div class="footer-menu-list-item">
              <a :href="'tel:' + settings.phone_1" target="hiddeniframe">{{ settings.phone_1 }}</a>
            </div>
            <div class="footer-menu-list-item">
              <a :href="'tel:' + settings.phone_2" target="hiddeniframe">{{ settings.phone_2 }}</a>
              <iframe name="hiddeniframe" style="visibility:hidden;width:0;height:0;"></iframe>
            </div>
          </li>
          <li class="footer-menu-lists">
            <div class="footer-menu-list-item footer-title">Адреса</div>
            <div class="footer-menu-list-item">{{ settings.sity }}</div>
            <div class="footer-menu-list-item">{{ settings.street }}</div>
          </li>
          <li class="footer-menu-lists">
            <div class="footer-menu-list-item footer-title">Соц. Мережі</div>
            <div class="footer-menu-list-item socials-container">
              <ul class="socials-container Dark-Blue">
                <li class="socials-item">
                  <a
                    class="socials-item-icon-container hidden-xs-only"
                    :href="settings.viber"
                    target="_blank"
                  >
                    <IconBase height="16" icon-name="Viber" width="16">
                      <ViberBlack />
                    </IconBase>
                  </a>
                  <a
                    class="socials-item-icon-container hidden-sm-and-up"
                    :href="settings.viber"
                    target="_blank"
                  >
                    <IconBase height="16" icon-name="Viber" width="16">
                      <ViberBlack />
                    </IconBase>
                  </a>
                </li>
                <li class="socials-item">
                  <a
                    class="socials-item-icon-container"
                    :href="settings.telegram"
                    target="_blank"
                  >
                    <IconBase height="16" icon-name="Telegram" width="16">
                      <TelegramBlack />
                    </IconBase>
                  </a>
                </li>
                <li class="socials-item">
                  <a
                    class="socials-item-icon-container"
                    :href="settings.facebook"
                    target="_blank"
                  >
                    <IconBase height="16" icon-name="Facebook" width="16">
                      <FacebookBlack />
                    </IconBase>
                  </a>
                </li>
                <li class="socials-item">
                  <a
                    class="socials-item-icon-container"
                    :href="settings.instagram"
                    target="_blank"
                  >
                    <IconBase height="16" icon-name="Instagram" width="16">
                      <InstagramBlack />
                    </IconBase>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer_mobile />
    <div class="copyright-wrapper">
      <div class="copyright-content">
        <div class="copyright-icon">
          <IconBase height="10" width="10">
            <Copyright />
          </IconBase>
        </div>
        <a class="copyright-text" href="#"> {{ new Date().getFullYear() }} UX. Всі права захищенні </a>
      </div>
    </div>
    <Footer_button />
  </div>
</template>

<script>
import IconBase from '../icons/IconBase'
import Copyright from '../icons/Copyright'
import ViberBlack from '../icons/ViberBlack'
import TelegramBlack from '../icons/TelegramBlack'
import FacebookBlack from '../icons/FacebookBlack'
import InstagramBlack from '../icons/InstagramBlack'
import Footer_button from '@/components/common/Footer_button'
import Footer_mobile from '@/components/common/Footer_mobile'
import { mapGetters } from 'vuex'
import { host } from '@/services/config'

export default {
  name: 'Footer',
  components: {
    InstagramBlack,
    FacebookBlack,
    TelegramBlack,
    ViberBlack,
    Copyright,
    IconBase,
    Footer_button,
    Footer_mobile,
  },
  data() {
    return {
      baseURL: host,
    }
  },
  computed: {
    ...mapGetters({
      logoData: 'getLogoData',
    }),
    settings() {
      let obj = {}
      for (let { key, value } of Object.values(this.$store.getters.getSettings))
        obj[key] = value

      return obj
    },
  },
}
</script>
